import React from "react"
import classNames from "classnames"

import { parseMaxCapacity, getOccupancyPct } from "../utils/occupancy"
import { getEventColor } from "../utils/gridUtils"

const GradeEventCard = ({
  schedule,
  onClick,
  isSelected,
  selectionMode = false,
  selectionType = 'regular',
  isEnrolled = false // Nova prop para indicar matrícula existente
}) => {
  const startTime = String(schedule?.startTime || "")
  const endTime = String(schedule?.endTime || "")

  const maxCapacityRaw = schedule?.maxCapacity
  const maxCapacity = parseMaxCapacity(maxCapacityRaw)
  const enrolledCount = Math.max(0, Number(schedule?.enrolledCount || 0))
  const occupancyPct = getOccupancyPct(enrolledCount, maxCapacityRaw)

  const activityName = schedule?.activityName || "Atividade"
  const rawName = schedule?.employeeName || ""
  const teacherDisplayName = rawName ? `Prof. ${rawName.split(" ")[0]}` : ""
  const areaName = schedule?.areaName || ""

  const color = getEventColor(schedule)

  const occupancyClass =
    occupancyPct === null
      ? ""
      : occupancyPct >= 1
        ? "grade-event--full"
        : occupancyPct >= 0.7
          ? "grade-event--busy"
          : "grade-event--ok"

  return (
    <div
      className={classNames("grade-event", occupancyClass, {
        "grade-event--selected": isSelected && !selectionMode,
        "grade-cell--selected": isSelected && selectionMode && selectionType === 'regular',
        "grade-cell--selected-trial": isSelected && selectionMode && selectionType === 'trial',
        "grade-cell--enrolled": isEnrolled && selectionMode, // Nova classe para matrícula existente
        "selectable": selectionMode
      })}
      style={color ? {
        backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)`,
        borderLeft: `3px solid ${color}`
      } : {}}
      onClick={(e) => {
        e.stopPropagation();

        if (onClick) onClick(e);
      }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {/* Capacity Badge absolutely positioned */}
      <div className="position-absolute top-0 end-0 m-2 mt-1 me-1 text-end">
        <span
          className="badge bg-white shadow-sm text-dark border border-light rounded-1 px-2 py-1 font-size-11"
          style={{ opacity: 0.95 }}
        >
          {enrolledCount}/{maxCapacity === "-" ? "—" : maxCapacity}
          {!!schedule?.experimentalCount && (
            <span className="ms-1 text-warning fw-bold">({schedule.experimentalCount})</span>
          )}
        </span>
      </div>

      <div className="d-flex flex-column h-100 position-relative z-1 pt-1 pb-2">
        {/* Activity Name takes full width, wrapping heavily if needed */}
        <div
          className="grade-event__title fw-bold font-size-13 lh-sm mb-2"
          style={{
            maxWidth: '100%',
            wordBreak: 'break-word',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}
        >
          {activityName}
        </div>

        {/* Metadata section (Flex grow pushes this down if there is space, or keeps it under title) */}
        <div className="d-flex flex-column gap-1 mt-auto">
          <div className="grade-event__meta font-size-11 fw-medium d-flex align-items-center">
            <i className="mdi mdi-clock-outline me-1"></i>
            {startTime} — {endTime}
          </div>

          {teacherDisplayName && (
            <div className="grade-event__meta font-size-11 d-flex align-items-center" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <i className="mdi mdi-account-star-outline me-1"></i>
              {teacherDisplayName}
            </div>
          )}

          {areaName && (
            <div className="grade-event__meta font-size-11 d-flex align-items-center" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <i className="mdi mdi-map-marker-outline me-1"></i>
              {areaName}
            </div>
          )}
        </div>
      </div>

      {schedule?.attendanceCompleted && (
        <div className="position-absolute bottom-0 end-0 m-1 me-2 z-1 text-success fs-5" title="Presença confirmada">
          <i className="mdi mdi-check-circle"></i>
        </div>
      )}

      {color && (
        <svg className="position-absolute bottom-0 start-0 w-100" style={{ height: '25px', zIndex: 0, opacity: 0.6 }} viewBox="0 0 120 25" preserveAspectRatio="none">
          <path d="M0,20 Q30,22 60,18 T120,15 L120,25 L0,25 Z" fill={color} fillOpacity="0.12" />
          <path d="M0,15 Q20,18 40,14 T80,12 Q100,10 120,13 L120,25 L0,25 Z" fill={color} fillOpacity="0.06" />
        </svg>
      )}
    </div>
  )
}

export default GradeEventCard
